import React from 'react';
// /////////////////////////////////////////////////////////////////////////////////////////////////
const dialogState = {
  openAppLoaderOverlay: { open: false }, // default is true, Application will turn it off
  openPasswordEntryDialog: { open: false },
  openPasswordResetDialog: { open: false },
  openCoachingDialog: { open: false },
  openMarkAsServicedDialog: { open: false },
  openDeletionConfirmationDialog: { open: false },
  openSessionExpiredDialog: { open: false },
  openMoveDeviceConfirmationDialog: { open: false },
};

const dialog = (state = dialogState, { type, ...rest }) => {
  switch (type) {
    case 'dialog/set':
      return { ...state, ...rest };

    default:
      return state;
  }
};

export default dialog
